import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-grid">
          <div className="footer-column">
            <h3>Company</h3>
            {/* <Link to="/careers" className="footer-link">Careers</Link> */}
            {/* <Link to="/blog" className="footer-link">Blog</Link> */}
            <Link to="/faq" className="footer-link">FAQ</Link>
            {/* <Link to="/contact" className="footer-link">Contact Us</Link> */}
          </div>
          <div className="footer-column">
            <h3>Legal</h3>
            <Link to="/privacy-policy" className="footer-link">Privacy Policy</Link>
            <Link to="/terms" className="footer-link">Terms of Use</Link>
          </div>
          {/* <div className="footer-column">
            <h3>Resources</h3>
            <Link to="/help" className="footer-link">Help Center</Link>
            <Link to="/guides" className="footer-link">User Guides</Link>
            <Link to="/support" className="footer-link">Support</Link>
          </div> */}
          {/* <div className="footer-column">
            <h3>Connect</h3>
            <Link to="/social/Instagram" className="footer-link">Instagram</Link>
            <Link to="/social/facebook" className="footer-link">Facebook</Link>
            <Link to="/social/linkedin" className="footer-link">LinkedIn</Link>
          </div> */}
        </div>

        <div className="footer-disclaimer" style={{ fontSize: '0.65rem', paddingBottom: '0.01rem' }}>
          <p><strong>Legal Disclaimer:</strong></p>
          <p>Patients Empowered does not provide medical advice and is intended for informational and educational purposes only. This tool may leverage artificial intelligence to generate results, which may produce incorrect or misleading information. It is not a substitute for professional medical advice, diagnosis, or treatment. Never ignore professional medical advice in seeking treatment because of something you have read on this website. By using this website, users accept full responsibility for any consequences and cannot hold the creators of the system or the company or any affiliates responsible for any outcomes. This product/service is not designed, intended or made available as a medical device and should not be used to replace or as a substitute for professional medical advice, diagnosis, treatment, or judgment. If you think you may have a medical emergency, immediately call your doctor or dial 911.</p>
        </div>

        <div className="footer-bottom" style={{ fontSize: '0.8rem', paddingBottom: '0.2rem', paddingTop: '0.2rem' }}>
          <p>&copy; {new Date().getFullYear()} Patients Empowered. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;